import React, { Dispatch, SetStateAction, useEffect, useMemo } from 'react'
import { ReactComponent as Logo } from '../../assets/logo_white.svg'
import Menu from './Menu'
import style from './style.module.scss'
import SubMenu from './SubMenu'
import clsx from 'clsx'
import { menuItemParams } from '../../types'
import { SearchBar } from './SearchBar'

type mainHeaderParams = {
    menu: menuItemParams[]
    external: string
    sticky?: boolean
    active: number | null
    setActive: Dispatch<SetStateAction<number | null>>
    isSearchOpen: boolean
    toggleSearch: () => void
}

const MainHeader: React.FC<mainHeaderParams> = ({
    menu,
    external,
    sticky,
    active,
    setActive,
    isSearchOpen,
    toggleSearch,
}) => {
    // Loop in all submenus to create array
    const subMenu = useMemo(() => {
        let array: menuItemParams[][] = []
        for (const item of menu) {
            if (item.children) {
                array = [...array, item.children]
            }
        }
        return array
    }, [menu])

    const handleClick = (e: React.MouseEvent<HTMLElement>, id: number) => {
        e.preventDefault()
        setActive((old) => (old === id ? null : id))
    }

    useEffect(() => {
        if (sticky) {
            setActive(null)
        }
    }, [sticky, setActive])

    return (
        <>
            <div className={clsx(style.main, (active || isSearchOpen) && style.open)}>
                <div className={style.container}>
                    <div className={style.top}>
                        <a href={'/'}>
                            <Logo />
                        </a>

                        <Menu
                            menu={menu}
                            handleClick={handleClick}
                            external={external}
                            active={active}
                            isSearchOpen={isSearchOpen}
                            toggleSearch={toggleSearch}
                        />
                    </div>
                    {subMenu.map((menu, index) => (
                        <SubMenu key={index} subMenu={menu} isActive={active === index} />
                    ))}
                </div>
            </div>

            {isSearchOpen ? <SearchBar /> : null}
        </>
    )
}

export default MainHeader
